<template>
    <div>
      <div class="login" v-if="notExist">
        <label class="login">该序列号不存在！</label><br><br>
        <a-button type='primary' @click="back">确定</a-button>
      </div>
      
      <div class="login" v-if="Exist">
        <a-input addon-before="产品：" disabled = "true" default-value="" v-model="name"/>
      </div>
      
      <div class="login" v-if="Exist">
        <a-input addon-before="版本："  default-value="" v-model="version"/>
      </div>
      <div class="login" v-if="Exist">
        <a-input addon-before="控制器版本："  default-value="" v-model="controlversion"/>
      </div>
      
      <div class="login" v-if="Exist">
        <a-button type='primary' @click="submit">确定</a-button>
      </div>
      <a-upload
    name="file"
    :multiple="true"
    action="/api/version/upload"
    :headers="headers"
    @change="handleChange"
  >
    <a-button>
      <upload-outlined></upload-outlined>
      Click to Upload
    </a-button>
  </a-upload>
    </div>
  </template>
  <script>
  export default {
    data(){  
      return {
        user:"",
        SN:"",
        name:this.$store.state.productname,
        version:"",
        controlversion:"",
        notExist:false,
        Exist:false,
    }
    },
    created()
    {
      let sn = this.$store.state.productname;
      
      if(sn.length > 0){
      let param = {
          name:sn
      }
      let obj = this.$qs.stringify(param)
      this.$axios({
        method:'post',
        url:'/api/version/query',
        data: obj
      }).then((response) =>{    
              //这里使用了ES6的语法
        if(response.data.length>0){
          this.Exist = true
          this.notExist = false
        let result = response.data[0]
        this.version = result["version"];
        this.controlversion = result["controlversion"];
        this.creator = result["creator"];
        this.location = result["location"]
         console.log(response)       //请求成功返回的数据
        }
        else{
          this.Exist = false
          this.notExist = true
          console.log("not exist!")
        }
      }).catch((error) =>{
        
        console.log(error)       //请求失败返回的数据       
      })
      }
    },
    methods:{
          back(){
            this.$router.push('/home/versionlist')
          },
          submit (){
              let param = {
                name:this.name,
                version:this.version,
                control:this.controlversion
              }
              let obj = this.$qs.stringify(param)
              if(this.name=="")
              {
                alert("请完善信息！")
              }
              else
              {
                let sn = this.$store.state.productname;
                if(sn.length>0){
  
                  this.$axios({
                  method:'post',
                  url:'/api/version/update',
                  data: obj
              }).then((response) =>{          //这里使用了ES6的语法
                let result = response.data
                if(result)
                {
                  this.$store.state.productname=""
                  this.$router.push('/home/versionlist')
                }
  
                  console.log(response)       //请求成功返回的数据
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
                  
        })
                }
                else
                {
                  this.$axios({
                  method:'post',
                  url:'/api/version/newproduct',
                  data: obj
              }).then((response) =>{          //这里使用了ES6的语法

            
                let result = response.data
                if(result["result"])
                {
                  this.$store.state.productname=""
                  this.$router.push('/home/versionlist')
                }
  
                  console.log(response)       //请求成功返回的数据
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
                  
        })}
                
              }
  
          },
         
          
    }
  }
  </script>
  <style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .login {
    margin-top:20px;
    margin-left:auto;
    margin-right:auto;
    width:300px
  
  }
  </style>


// WEBPACK FOOTER //
// src/components/NewProduct.vue